import type { SubjectRow } from '../types';

export const validateSubjectRows = (_: any, value: SubjectRow[]) => {
  if (!value || value.length === 0) {
    return Promise.reject(new Error('Добавьте хотя бы один предмет'));
  }

  for (let i = 0; i < value.length; i++) {
    const row = value[i];
    if (!row.subjectId) {
      return Promise.reject(new Error(`Выберите предмет в строке ${i + 1}`));
    }
    //TODO: Временно отключили валидацию классов, для проверки удобства пользователей - 28.08.2026
    // if (!row.educationalClassIds || row.educationalClassIds.length === 0) {
    //   return Promise.reject(new Error(`Выберите классы в строке ${i + 1}`));
    // }
  }

  return Promise.resolve();
};
